import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class VisitorService {
  public async addVisitor(visitorModel: any) {
    let jsonBody = JSON.stringify(visitorModel);
    try {
      let response = await fetch(`${BASE_URL}/visitors/add`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        credentials: "include",
        body: jsonBody,
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async editVisitor(visitorModel: any) {
    let jsonBody = JSON.stringify(visitorModel);
    try {
      let response = await fetch(`${BASE_URL}/visitors/${visitorModel._id}`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        credentials: "include",
        body: jsonBody,
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async deleteVisitor(visitorModel: any) {
    try {
      let response = await fetch(`${BASE_URL}/visitors/${visitorModel._id}`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async deleteAllSelectedVisitors(selectedList: any) {
    try {
      let response = await fetch(`${BASE_URL}/visitors/delete/multiple`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(selectedList),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async getVisitorsByCompanyId(companyId: String) {
    try {
      let response = await fetch(
        `${BASE_URL}/visitors/companies/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public getVisitorsByCompanyIdAsync(
    companyId: String,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(`${BASE_URL}/visitors/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e:any) {
      onFailure(e);
    }
  }
}
